import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextMiningApplier"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.0009 19.8547H12.0001L3.21311 9.71625L7.12511 4.5H16.8751L20.7871 9.71625L18.3571 12.519L19.4919 13.5015L22.7131 9.78375L17.6251 3H6.37511L1.28711 9.78375L10.8661 20.8365L12.0009 19.8547ZM15.0001 14.25L20.2501 18L15.0001 21.75V14.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextMiningApplier.vue"]]);
